import React, { useEffect, useState } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import ListaEspecialidades from "../ListaEspecialidades";
import {
  getEspecialidades,
  insertEspecialidad,
  changeStatusEspecialidad,
  getAgencias,
  changeStatusAgencia,
  insertAgencia,
  getPermissions,
} from "../../utils/utils";
import { sections } from "../../utils/properties";

const Agencias = ({ parentCallback, disabled }) => {
  const history = useHistory();
  let { id } = useParams();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [agencias, setAgencias] = useState([]);
  const [nuevaAgencia, setNuevaAgencia] = useState([]);
  const [permissions, setPermissions] = useState("");

  console.log(errors);

  useEffect(() => {
    getAgencias().then((agencias) => {
      setAgencias(agencias);
    });
    getPermissions().then((permissions) => {
      setPermissions(permissions);
      if (
        !(
          permissions.length > 0 &&
          permissions.some((e) => e.id_section === sections.ADMINISTRACION)
        )
      ) {
        history.push("/bienvenido");
      }
    });
  }, []);

  return (
    <div>
      {permissions.length > 0 &&
        permissions.some((e) => e.id_section === sections.ADMINISTRACION) && (
          <div>
            <div className="mt-3">
              <div className="row align-items-center">
                <div className="col-6">
                  <h1>Agencias</h1>
                </div>
                <div className="col-6 text-end">
                  <button
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#staticBackdrop"
                    className="btn btn-warning"
                    id="myBtn"
                  >
                    Nueva agencia
                  </button>
                </div>
              </div>
            </div>
            <div className="my-5">
              <table className="table table-sm table-hover">
                <thead>
                  <tr>
                    <th style={{ width: 0 + "%" }}>#</th>
                    <th className="col-10">Agencia</th>
                    <th className="col-1">¿Habilitado?</th>
                  </tr>
                </thead>
                <tbody>
                  {agencias.length > 0
                    ? agencias.map((agencia) => {
                        return (
                          <tr key={agencia.age_id}>
                            <td>{agencia.age_id}</td>
                            <td>{agencia.age_nombre}</td>
                            <td className="">
                              <div className="form-check form-switch d-flex justify-content-center">
                                <input
                                  checked={agencia.age_status === "1"}
                                  className="form-check-input"
                                  type="checkbox"
                                  id="flexSwitchCheckDefault"
                                  onClick={(e) => {
                                    changeStatusAgencia([
                                      { id: agencia.age_id },
                                    ]).then(() => {
                                      getAgencias().then((agencias) => {
                                        setAgencias(agencias);
                                      });
                                    });
                                  }}
                                />
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    : ""}
                </tbody>
              </table>
            </div>
          </div>
        )}

      <div
        className="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">
                Nueva agencia
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <label htmlFor="fechaAgenda">Nombre agencia</label>
              <input
                className="form-control"
                type="text"
                id="nombreNuevaAgencia"
                onChange={(e) => {
                  setNuevaAgencia([{ name: e.target.value }]);
                }}
              />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
                onClick={() => {
                  insertAgencia(nuevaAgencia).then(() =>
                    getAgencias().then((agencias) => {
                      setAgencias(agencias);
                      document.getElementById("nombreNuevaAgencia").value = "";
                    })
                  );
                }}
              >
                Crear
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Agencias;
